<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/company/cardLists"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="user_mobile">
          <Input type="text" v-model="searchData.user_mobile" placeholder="手机号或姓名" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="car_number">
          <Input type="text" v-model="searchData.car_number" placeholder="车牌号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="company_id">
          <Select v-model="searchData.company_id" placeholder="所属车队" filterable>
            <Option v-for="(item,key) in companys" :value="item.company_id">{{item.company_name}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="is_bind">
          <Select v-model="searchData.is_bind" placeholder="是否注册">
            <Option value="">是否注册</Option>
            <Option value="1">已注册</Option>
            <Option value="-1">未注册</Option>
          </Select>
        </FormItem>
        <!--<FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" placeholder="开卡时间" style="width: 320px"></DatePicker>
        </FormItem>-->
      </template>

      <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="edit(0)">添加</Button>
        </FormItem>

        <FormItem>
          <Button type="warning" @click="exportCard()">导出</Button>
        </FormItem>
      </template>

    </pageTable>

    <editForm v-if="showEditForm"
              :show-edit="showEditForm"
              :card-id="editCardId"
              ref="Edit"
              @cancel-edit="cancelEdit"
              @edit-success="editSuccess"
    >
    </editForm>

    <cardEditBase v-if="editBaseData.isShow"
                  :show-edit="editBaseData.isShow"
                  :card-id="editBaseData.card_id"
                  ref="EditBase"
                  @cancel-edit="editBaseData.isShow = false"
                  @edit-success="editBaseData.isShow = false"
    >
    </cardEditBase>

    <Modal
            v-model="rechargeModal"
            :title="rechargeModalTitle"
            :loading="loadingRechargeModal"
            @on-ok="doRecharge"
            @on-cancel="cancelRechargeModal">
      <Form ref="rechargeForm" :label-width="100" :model="rechargeForm">
        <FormItem label="充值金额" prop="amount">
          <Input v-model="rechargeForm.amount" placeholder="请输入整数,负数则扣除余额" maxlength="100"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="rechargeForm.remark" placeholder="" maxlength="50"></Input>
        </FormItem>
      </Form>
    </Modal>

    <Drawer :title="snCardTitle" width="800"
            :value="showCardSnDrawer"
            :mask-closable="true"
            @on-close="closeCardSn">
        <cardSn :card-id="snCardId" v-if="showCardSnDrawer"></cardSn>
    </Drawer>



  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import editForm from "./cardEdit";
  import cardEditBase from "./cardEditBase";
  import cardSn from "./cardSn";
  import XLSX from 'xlsx';
  export default {
    name: "card",
    components:{pageTable,editForm,cardSn,cardEditBase},
    data() {
      return {
        showEditForm:false,
        editCardId:0,
        companys: [],
        searchData: {
          user_mobile: '',
          company_id:'',
          create_time:'',
          car_number:''
        },
        tableColumn: [
          {title: 'ID',key: 'card_id',align: "center"},
          {title: '车队',key: 'company_name',align: "center"},
          {title: '姓名',key: 'user_name',align: "center"},
          {title: '手机号',key: 'user_mobile',align: "center",width: 130},
          {title: '车牌号',key: 'car_number',align: "center"},
          {title: '余额(L)',key: 'balance',align: "center",render:(h,params)=>{
              return h('a',{
                on:{click:()=> {this.showCardSn(params.row)}}
              },params.row.balance)
            }},
          {title: '是否限额',key: 'card_type_name',align: "center"},
          {title: '是否注册',key: 'user_id',align: "center"},
          {title: '开卡时间',key: 'create_time',minWidth:120,align: "center"},
          {title: '操作',align: "center",width:140,render:(h,params)=>{
              return h('div',[
                h('Button',{
                  props: {type: 'primary', size: 'small'},
                  on: {click: () => {this.editBase(params.row.card_id)}}
                }, '编辑'),
               /* h('Button',{
                  props: {type: 'primary', size: 'small'},
                  style:{marginLeft:'5px'},
                  on: {click: () => {this.showRecharge(params.row)}}
                }, '充值'),*/
                h('Button',{
                  props: {type: 'error', size: 'small'},
                  style:{marginLeft:'5px'},
                  on: {click: () => {this.del(params.row)}}
                }, '删除'),
              ])
            }},
        ],
        tableData: [],

        rechargeModal:false,
        rechargeModalTitle:'',
        loadingRechargeModal:true,
        rechargeForm:{
          card_id:0,
          amount:'',
          remark:'',
        },

        showCardSnDrawer:false,
        snCardId:0,
        snCardTitle:'车队卡流水记录',

        editBaseData:{
          isShow:false,
          card_id:0,
        }

      }
    },
    methods: {
      cancelEdit(){
        this.showEditForm = false
        this.editCardId = 0
      },
      editSuccess(){
        this.$refs.table.getLists();
        this.showEditForm = false
        this.editCardId = 0
      },
      edit(card_id){
        this.showEditForm = true
        this.editCardId = card_id
      },
      editBase(card_id){
        this.editBaseData.isShow = true
        this.editBaseData.card_id = card_id
      },
      showRecharge(info){
        this.rechargeModal = true
        this.rechargeModalTitle = info.user_mobile + ' 车队卡充值'
        this.rechargeForm.card_id = info.card_id
      },
      cancelRechargeModal(){
        this.rechargeModal = false
        this.rechargeForm.card_id = 0
      },
      async doRecharge(){
        if (this.rechargeForm.company_id<=0 || this.rechargeForm.amount<=0){
          return this.$commonFun.errorTip('请输入正确的金额')
        }
        let res = await this.$commonFun.postProxy('admin/company/dealCardBalance',this.rechargeForm);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.rechargeModal = false
            this.rechargeForm.card_id = 0
            this.$refs.table.getLists();
          })
        })
      },

      showCardSn(info){
        this.showCardSnDrawer = true
        this.snCardId = info.card_id
        this.snCardTitle = info.car_number
      },
      closeCardSn(){
        this.showCardSnDrawer = false
        this.snCardId = 0
      },
      del(info){
        this.$Modal.confirm({
          title:'删除',
          content:`确定要删除司机:${info.user_mobile} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/company/delCard',{card_id:info.card_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })
      },
      async exportCard(){
        let res = await this.$commonFun.postProxy('admin/company/exportCardLists',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`车队车辆.xlsx`)
        })
      }

    },
    mounted() {
      this.$commonFun.postProxy('admin/company/getAllCompany',{}).then((res)=>{
        this.companys = res.data
      })
    },
  }
</script>

<style scoped>

</style>
